import React from 'react'
import Form from 'react-bootstrap/Form'

/**
 * Shows a list of options to select a predicate for a specific column.
 * The predicate list us generated from the list the AppDeveloper decided on
 * when the table was created.
 */
const PredicateSelect = ({ value, onChange, disabled, list, uid }) => (
  <Form.Control as='select' value={value} onChange={(e) => { onChange(e, null, uid) }} disabled={disabled} className='m-2'>
    <option value />
    {
      list.map((pred, idx) => (
        <option value={pred} key={idx}>{pred.replace('_', ' ')}</option>)
      )
    }
  </Form.Control>
)

export default PredicateSelect
